export enum CustomerUniqueCheckType {
  Customer = 'CUSTOMER',
  Custodian = 'CUSTODIAN',
}
